<template>
  <b-container fluid>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Cerca Codice" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">x</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Per pagina" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Main table element -->
    <b-table show-empty
             striped
             outlined
             dark
             stacked="md"
             :items="items"
             :fields="fields"
             :current-page="currentPage"
             :per-page="perPage"
             :filter="filter"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             :sort-direction="sortDirection"
             @filtered="onFiltered"
    >
      <!-- In some circumstances you may need to use @click.native.stop instead -->
      <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
      <template slot="state" slot-scope="row">
        <!-- In some circumstances you may need to use @click.native.stop instead -->
        <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
        <b-form-checkbox @click.native.stop @change="changeSmartboxState(row.item.state, row.item.tokenId)">
          {{row.value === 1 ?'Si':'No'}}
        </b-form-checkbox>
      </template>
      <template slot="row-details" slot-scope="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <!-- Info modal -->
    <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
    </b-modal>

  </b-container>
</template>

<script>
  const items = []

  export default {
    data () {
      return {
        items: [],
        state: '',
        fields: [
          { key: 'tokenId', label: 'Codice smartbox', sortable: true, sortDirection: 'desc' },
          { key: 'nome', label: 'Nome smartbox', sortable: true, 'class': 'text-center' },
          { key: 'state', label: 'Utilizzato', sortable: true }
        ],
        currentPage: 1,
        perPage: 5,
        totalRows: items.length,
        pageOptions: [ 5, 10, 15 ],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        modalInfo: { title: '', content: '' }
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          prod_rem: 'Smartbox aggiornato !',
          prb_prod_rem: 'Errore',
        },
        en: {
          prod_rem: 'Smartbox aggiornato !',
          prb_prod_rem: 'Error',
        }
      }
    },
    computed: {
      sortOptions () {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => { return { text: f.label, value: f.key } })
      }
    },
    mounted: function (){
      this.getAllTokens()
    },
    methods: {
      stampaRow: function (row){
        console.log(row)
      },
      changeSmartboxState: function (state, tokenId) {
        this.$http.put('/ws-admin/smartbox/state', {state: state === 0 ? 1 : 0, token: tokenId}, {emulateJSON: true}).then(response => {
          if (response.body.rc === 0) {
            this.$toasted.show(this.$t('prod_rem'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'success',
              duration: 4000
            })
            this.getAllTokens()
          } else {
            this.$toasted.show(this.$t('prb_prod_rem'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'error',
              duration: 4000
            })
          }
        })
      },
      getAllTokens: function () {
        this.$http.get('/ws-admin/smartbox/all').then(response => {
          this.items = response.body.data
        })
      },
      info (item, index, button) {
        this.modalInfo.title = `Row index: ${index}`
        this.modalInfo.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', 'modalInfo', button)
      },
      resetModal () {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
      },
      onFiltered (filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  table {
    border-collapse: inherit;
  }

  .table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: #383839;
  }

  .table-dark {
    background-color: #202127;
    border: 1px solid white;
  }

  .table-dark.table-bordered {
    border: 1px solid white;
  }
  /*.container-fluid {*/
    /*color: black;*/
    /*background-color: white;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/SmartboxCode.vue